import { useEffect, useRef } from "react";

/**
 * useRefEffect is a custom hook that runs an effect
 * when the value of a ref changes.
 * @param refValue
 * @param action
 */
export function useRefEffect<T>(refValue: T, action: () => void) {
  const ref = useRef(refValue);
  useEffect(() => {
    if (ref.current !== refValue) {
      action();
    }
    ref.current = refValue;
  }, [refValue, action]);
}
